import React, { Component } from 'react';
import { translate } from 'react-i18next';
import axios from 'axios';
import moment from 'moment-timezone';
import brandLogo from '../../../images/Portada_ios.png';

class PreBook extends Component {
    render() {
        const reservation = this.props.reservation
        const endDate = moment(reservation.fecha_final, 'YYYY-MM-DD HH:mm:ss');
        const startDate = moment(reservation.fecha_inicial, 'YYYY-MM-DD HH:mm:ss');
        const duration = reservation.duracion;
        const { t } = this.props;
        return (
            <div>
                <button
                    className="hidden"
                    data-target="#modalSuccess"
                    data-toggle="modal"
                    id="btnSuccess"
                    type="button">
                </button>
                <div className="modal fade" id="modalSuccess" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header COVID-HEADER">
                                <button type="button" className="close btn-primary" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style={{ fontSize: '30px', background: 'red', width: '30px', display: 'block' }}>&times;</span></button>
                                <div className="navbar-header">
                                    <div className="navbar-brand">
                                        <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body">
                                <h3>Nueva Reservación</h3>
                                <div className="card-panel-body">
                                    <div className="form-group card-panel panel panel-default card center-block" style={{ display: 'block', padding: '10px' }}>
                                        <h5 className="iossala">{reservation.name}</h5>

                                        <div className="panel-description-text">
                                            {reservation.descripcion}
                                        </div>
                                        <div className="contenedor">
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                            &ensp;
                                            {startDate.format('ll')}
                                        </div>
                                        <div className="contenedor">
                                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                                            &ensp;
                                            {startDate.format('HH:mm')} - {endDate.format('HH:mm')}
                                        </div>
                                        {/* {duration === '4' ? (
                                            "Precio de Sala por 2 Horas $" + room.hrs_2
                                        ) : (
                                            duration === '8' ? (
                                                "Precio de Sala por 4 Horas $" + room.hrs_4
                                            ) : (
                                                "Precio de Sala por un dia Completo $" + room.full_day
                                            )
                                        )} */}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer panel-body-bottom">
                                <button
                                    className="btn btn-primary btn-search-resvations"
                                    data-dismiss="modal"
                                    style={{ background: "#33CCCC", border: "1px solid #33CCCC" }}
                                    onClick={() => this.props.handleGoToPay()}
                                    type="button">
                                    Pagar Ahora
                                </button>
                                <button
                                    className="btn btn-default btn-secondary btn btn-primary btn-search-resvations"
                                    data-dismiss="modal"
                                    style={{ background: "#FFF", border: "1px solid #3CC", color: "#3CC" }}
                                    type="button">
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(PreBook);


// WEBPACK FOOTER //
// ./src/dashboard/store/Reservation/PreBook.js